module.exports = __webpack_public_path__ + "static/media/3DPPA22.2de77854.jpg";